"use strict";

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports.LIST_VIEW = exports.GRID_VIEW = void 0;
var GRID_VIEW = "grid";
exports.GRID_VIEW = "grid";
var LIST_VIEW = "list";
exports.LIST_VIEW = "list";